/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreatePolicyV2Request extends models.PolicyV2Base {
    getFixupPrototypeFunction() { return CreatePolicyV2Request.fixupPrototype; }

    static newInstance(model: Partial<CreatePolicyV2Request>): CreatePolicyV2Request {
        let obj = Object.assign(new CreatePolicyV2Request(), model);
        CreatePolicyV2Request.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreatePolicyV2Request>): CreatePolicyV2Request {
        if (!model) return null;
        return CreatePolicyV2Request.newInstance(<CreatePolicyV2Request> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreatePolicyV2Request) {
        if (!obj) return;

        models.CreatePolicyV2Request.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreatePolicyV2Request): boolean {
        if (models.PolicyV2Base.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreatePolicyV2Request.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

}
